import React from "react";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../utils/oidcUserManager";
import { connect, useDispatch } from "react-redux";
import * as actions from "../../modules/Auth/_redux/authActions";
import {setInit} from "../../../redux/settingsSlice";

function CallbackPage(props) {

  const dispatch = useDispatch();

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={(user) => {
        dispatch(actions.login(user));
          dispatch(setInit())
          props.history.replace(user.state.path || "/");
      }}
      errorCallback={error => {
        props.history.push("/");
        console.error(error);
      }}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
}

export default connect()(CallbackPage);
